import { memo } from "react"

import { BaseTopBar } from "../TopBars/BaseTopBar"

export const ProcedureTypeSettingsViewTopBar = memo(() => {
	return <BaseTopBar showAIButton={false} />
})
ProcedureTypeSettingsViewTopBar.displayName = "ProcedureTypeSettingsViewTopBar"
